/*
 * @Author: micoin_simith 467441151@qq.com
 * @Date: 2021-12-15 16:58:56
 * @LastEditors: micoin_simith 467441151@qq.com
 * @LastEditTime: 2023-10-30 19:01:53
 * @FilePath: /meeting_management/src/main.js
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'
// router setup
import routes from './routes/routes'
import $ from 'jquery'
import {
  get,
  post,
  delet,
  postform
} from "./api/http";
import moment from 'moment';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
/* 地图 */
import BaiduMap from 'vue-baidu-map';
// 引入echarts
import echarts from 'echarts'
/* cookie */
import VueCookies from 'vue-cookies'

import {setCookie,getCookie,delCookie} from '@/assets/cookie'
Vue.prototype.$cookieStore = {setCookie,getCookie,delCookie}
/* animated */
import animated from 'animate.css'


Vue.use(animated)
//  全局过滤器 时间戳
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment.unix(dataStr).format(pattern)
})
Vue.filter('dateformats', function (dataStr, pattern = 'YYYY-MM-DD') {
  return moment.unix(dataStr).format(pattern)
})
Vue.use(BaiduMap, {
  ak: '4VWHfbyLFc9o7BGgyaR1FvzM3r5IjhQH'
})
Vue.use(ElementUI);
// plugin setup
Vue.use(VueRouter);
// 为什么要加catch？
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(LightBootstrap);
Vue.use(VueCookies)

//定义全局变量
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$postform = postform;
Vue.prototype.$delet = delet;
Vue.prototype.$echarts = echarts
//接口地址
import api from '../src/api/API_KEY'
Vue.prototype.APIurl = api;
// 路由
const router = new VueRouter({
  // mode: "history",
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  $
})
